import { t } from "i18next";
import { Trans } from "react-i18next";
import { Button, Icon } from "@livingmap/hippo";

import styles from "./Modal.module.scss";

interface Props {
  featureName: string | undefined;
  closeModal: () => void;
  onTemporarilyClose: () => void;
}

const TemporarilyClose: React.FC<Props> = ({
  featureName,
  closeModal,
  onTemporarilyClose,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h5 className={styles.title}>{t("modals.temporarily_close.title")}</h5>
        <button className={styles.closeButton} onClick={closeModal}>
          <Icon dataQA="close-icon" name="close" size={18} />
        </button>
      </div>
      <div className={styles.contentContainer}>
        <p className={styles.description}>
          <Trans
            i18nKey="modals.temporarily_close.description"
            values={{ featureName }}
          >
            <span />
          </Trans>
        </p>
        <div className={styles.buttonWrapper}>
          <Button
            dataQA="cancel-button"
            type="primary"
            size="regular"
            style="filled"
            text={t("btn_labels.cancel")}
            onClick={closeModal}
          />
          <Button
            dataQA="temporarily-close-button"
            type="negative"
            size="regular"
            style="filled"
            text={t("modals.temporarily_close.btn_labels.temporarily_close")}
            onClick={onTemporarilyClose}
          />
        </div>
      </div>
    </div>
  );
};

export default TemporarilyClose;
